<div *ngIf="!acceptFolder; else uploadFolder" class="import-file input-file-container">
    <h3>{{ 'SelectFiles' | translate }}</h3>

    <div (dragenter)="isDragEnter = true"
         (dragleave)="isDragEnter = false"
         (dragover)="onDragOver($event)"
         (drop)="onDrop($event)"
         [ngClass]="{'drag-start': isDragEnter}"
         class="file-selector">
        <div class="input-label-container">
            <label for="file"><strong>{{ 'ChooseFile' | translate }}</strong></label>

            <input (change)="onFileSelected($event)" (click)="$event.target.value=null" [accept]="acceptedTypeFile"
                   id="file" multiple type="file">

            <div class="box__dragndrop"> {{ 'DragHere' | translate }}</div>
        </div>
    </div>
</div>

<ng-template #uploadFolder>
<div class="import-file input-file-container">
    <h3>{{ 'SelectFolders' | translate }}</h3>

    <div (dragenter)="isDragEnter = true"
         (dragleave)="isDragEnter = false"
         (dragover)="onDragOver($event)"
         (drop)="onDrop($event)"
         [ngClass]="{'drag-start': isDragEnter}"
         class="file-selector">
        <div class="input-label-container">
            <label for="folder"><strong>{{ 'ChooseFolder' | translate }}</strong></label>

            <input (change)="onFileSelected($event)" (click)="$event.target.value=null"
                   id="folder" multiple type="file" webkitdirectory>

            <div class="box__dragndrop"> {{ 'DragHereFolder' | translate }}</div>
        </div>
    </div>
</div>
</ng-template>
